import Env from 'helpers/Env';
const publicPath = Env.getPublicPath();

const path = (url: string): string => {
  return `${publicPath}${url}`;
};

export default path;
